import {customAxios} from "../customAxios";
import {useState} from "react";
import {LeasePackageImportDto, LeasePackageMultiImportDto, LeasePackageMultiImportSimpleDto} from "../../model/Imports";

export function useGetMultiImports() {
    const [loading, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<LeasePackageMultiImportSimpleDto[]>([]);
    const [error, setError] = useState<Error>();

    async function execute() {
        try {
            setLoading(true);
            setError(undefined);
            const data = await getMultiImports();
            setData(data);
            return data;
        }
        catch (e) {
            setError(e as Error);
            return Promise.reject(e);
        }
        finally {
            setLoading(false);
        }
    }

    return {
        loading, data, error, execute
    };
}

export async function getMultiImports(): Promise<LeasePackageMultiImportSimpleDto[]> {
    const response = await customAxios.get<LeasePackageMultiImportSimpleDto[]>(`/v1/lease-packages/import/multi`, );
    return response.data;
}

